<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    :fill="color"
    fill-rule="evenodd"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color }"
  >
    <defs>
      <path
        id="check-path-1"
        d="M10,0 C15.5208333,0 20,4.47916667 20,10 C20,15.5208333 15.5208333,20 10,20 C4.47916667,20 0,15.5208333 0,10 C0,4.47916667 4.47916667,0 10,0 Z M10,2 C5.58333333,2 2,5.58333333 2,10 C2,14.4166667 5.58333333,18 10,18 C14.4166667,18 18,14.4166667 18,10 C18,5.58333333 14.4166667,2 10,2 Z M14.1123874,6.36247772 L15.526601,7.77669128 L9.16263995,14.1406523 L4.91999926,9.89801163 L6.33421282,8.48379806 L9.16263995,11.3122252 L14.1123874,6.36247772 Z"
      ></path>
    </defs>
    <g id="Icon-/-Tick-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Mask/LS_Green">
        <mask id="check-mask-2" fill="white"><use xlink:href="#check-path-1"></use></mask>
        <g id="Rectangle" mask="url(#check-mask-2)" :fill="color">
          <g transform="translate(-4.000000, -4.000000)">
            <rect x="0" y="0" width="29" height="29"></rect>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'CheckSVG',
  props: {
    size: VueTypes.number.isRequired,
    color: VueTypes.string.isRequired,
  },
};
</script>

<style></style>
